import React, { FC } from 'react';

import FolderBreadcrumbs from './FolderBreadcrumbs';
import styles from './MyFilesHeader.module.scss';
import ExtraContent from './ExtraContent';

const MyFilesHeader: FC = () => (
    <div data-testid="myFilesHeader_container" className={styles['my-files-header']}>
        <FolderBreadcrumbs />
        <ExtraContent />
    </div>
);

export default MyFilesHeader;
